// App.tsx - Complete with Operation User Redirection Fix + Bulk Order Management Access for All Users
// FIXED: Admin users can access Return Process Management

import { BrowserRouter as Router, Routes, Route, Navigate, useLocation, useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import Dashboard from './pages/Dashboard.tsx';
import SignIn from './pages/auth/signin.tsx';
import SignUp from './pages/auth/signup.tsx';
import VerifyOTPSignin from './pages/auth/verifyotp_signin.tsx';
import VerifyOTPSignup from './pages/auth/verifyotp_signup.tsx';
import UserProfile from './pages/user_profile.tsx';
import Cart from './pages/cart.tsx';
import PaymentMethod from './pages/payment_method.tsx';
import ConfirmOrder from './pages/order_confirm.tsx';
import OrderPlaced from './pages/order_placed.tsx';
import PasswordAssistance from './pages/auth/reset_app_password/password_assistance.tsx';
import AP_Email_Verification from './pages/auth/reset_app_password/ap_email_verification.tsx';
import AP_Number_Verification from './pages/auth/reset_app_password/ap_number_verification.tsx';
import ResetNewPassword from './pages/auth/reset_app_password/reset_new_password.tsx';
import Product from './pages/product.tsx';
import ProductDetail from './pages/product_detail.tsx';
import StripeCheckout from './pages/static_stripe_checkout.tsx';
import ViewOrder from './pages/view_order.tsx';
import AdminDashboard from './pages/admin/adminDashboard.tsx';
import ManageProduct from './pages/admin/manageProductsList.tsx';
import Slidemenu from './components/admin/adminSlidemenu.tsx';
import AdminHeader from './components/admin/adminHeader.tsx';
import OrderManagement from './components/admin/adminSlidemenu.tsx';
import Addproduct from './pages/admin/addproduct.tsx';
import CategoryManagement from './pages/admin/catergoryManagement.tsx';
import Banner from './pages/admin/banner.tsx';
import SubBanner from './pages/admin/subBanner.tsx';
import DealOfTheDay from './pages/admin/dealoftheday.tsx';
import SmptSettings from './pages/admin/smtpsettings.tsx';
import GlobalSettings from './pages/admin/globalSettings.tsx';
import SmsSettings from './pages/admin/smsSettings.tsx';
import UnitManagement from './pages/admin/unitManagement.tsx';
import AdminOrderManagement from './pages/admin/adminOrderManagement.tsx';
import SubCategoryManagement from './pages/admin/subCategoryMangement.tsx';
import Analytics from './pages/admin/analytics.tsx';
import PickupMessage from './pages/admin/pickupMessage.tsx';
import AdminLogin from './pages/admin/adminlogin.tsx';
import DeliveryManagement from './pages/admin/DeliveryManagement.tsx';
import ShippingManagement from './pages/admin/shippingManagement.tsx';
import ProductManagement from './pages/admin/productManagement.tsx';
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Reviews } from '@mui/icons-material';
import ReviewManagement from './pages/admin/review.tsx';
import SetCredit from './pages/admin/setCredit.tsx';
import GuestOrderList from './pages/admin/guestOrderlist.tsx';
import GuestUserOrder from './pages/admin/guestUserOrder.tsx';
import VendorLogin from './pages/admin/vendorlogin.tsx';
import UserList from './pages/admin/Userlist.tsx';
import FlashSale from './pages/admin/flashSale.tsx';
import Bundle from './pages/admin/bundle.tsx';
import DeliveryAgentManagement from './pages/admin/deliveryAgent.tsx';
import WareHoueManagement from './pages/admin/warehouseManagement.tsx';
import WarrantyManagement from './pages/admin/WarrantyManagement.tsx';
import ProductWarehouseManagement from './pages/admin/ProductWarehouseManagement.tsx';
import CouponManagement from './pages/admin/couponManagement.tsx';
import RewardManagement from './pages/admin/RewardManagement.tsx';
import RewardSettingsManagement from './pages/admin/RewardSettingsManagement.tsx';
import AdminRewards from './pages/admin/AdminRewards.tsx';
import AdminCouponUsers from './pages/admin/AdminCouponUsers.tsx';
import Delivery from './pages/admin/deliverySettings.tsx';
import RegisterAdmin from './pages/admin/registeradmin.tsx';
import RoleMaster from './pages/admin/roleMaster.tsx';
import RoleMappingManagement from './pages/admin/roleMapping.tsx';
import AdminUserList from './pages/admin/adminUserList.tsx';
import PickupPending from './pages/admin/pickupPending.tsx';
import React from 'react';
import BulkOrderManagement from './pages/admin/bulkOrder.tsx';
import BundleManagement from './pages/admin/bundleManagement.tsx';
import ReturnProcessManagement from './pages/admin/returnProcessManagement.tsx';

// Global Redirect Component
const GlobalRedirect = () => {
  const location = useLocation();
  const navigate = useNavigate();
  
  useEffect(() => {
    // Check if user is logged in
    const token = localStorage.getItem('admin_token');
    if (!token) return;
    
    // Get user role
    const userRole = (
      localStorage.getItem('admin_type') || 
      localStorage.getItem('user_role') || 
      'operation'
    ).toLowerCase().trim();
    
    const isOperation = userRole === 'operation';
    const isVendor = userRole === 'vendor';
    const isAdmin = userRole === 'admin';
    const isSuperAdmin = userRole.includes('super');
    const currentPath = location.pathname;
    
    console.log("🌍 GlobalRedirect:", {
      path: currentPath,
      role: userRole,
      isOperation,
      isVendor,
      isAdmin,
      isSuperAdmin
    });
    
    // Operation users: ONLY allow Product Management, Order Management, and Bulk Order Management
    if (isOperation) {
      const allowedPaths = ['/productManagement', '/adminOrderManagement', '/bulkOrderManagement'];
      if (!allowedPaths.includes(currentPath)) {
        console.log("🔄 GlobalRedirect: Operation user trying to access restricted path - redirecting to Product Management");
        navigate('/productManagement', { replace: true });
      }
    }
    
    // Vendor users: Allow Product Management, Bundle Management, Bulk Order Management, and Return Process Management
    if (isVendor) {
      const allowedPaths = ['/productManagement', '/bundleManagment', '/bulkOrderManagement', '/returnprocessManagement'];
      if (!allowedPaths.includes(currentPath)) {
        console.log("🔄 GlobalRedirect: Vendor user trying to access non-allowed page - redirecting to Product Management");
        navigate('/productManagement', { replace: true });
      }
    }
    
    // Operation/Vendor users trying to access Dashboard
    if ((isOperation || isVendor) && currentPath === '/adminDashboard') {
      console.log("🔄 GlobalRedirect: Operation/Vendor user accessing Dashboard - redirecting to Product Management");
      navigate('/productManagement', { replace: true });
    }
  }, [location.pathname, navigate]);
  
  return null;
};

// Create an inline ProtectedRoute component
const ProtectedRoute: React.FC<{
  children: React.ReactNode;
  allowedRoles?: string[];
  redirectTo?: string;
}> = ({ children, allowedRoles = [], redirectTo }) => {
  const navigate = useNavigate();
  const location = useLocation();
  
  // Get user role
  const userRole = (
    localStorage.getItem('admin_type') || 
    localStorage.getItem('user_role') || 
    'operation'
  ).toLowerCase().trim();
  
  const isSuperAdmin = userRole.includes('super');
  const isAdmin = userRole === 'admin';
  const isOperation = userRole === 'operation';
  const isVendor = userRole === 'vendor';
  
  console.log("🛡️ ProtectedRoute Check:", {
    path: location.pathname,
    userRole,
    isSuperAdmin,
    isAdmin,
    isOperation,
    isVendor,
    allowedRoles
  });
  
  // Check if user is authenticated
  const token = localStorage.getItem('admin_token');
  if (!token) {
    console.log("❌ No token - redirecting to login");
    return <Navigate to="/" replace />;
  }
  
  // Check if this is the initial login redirect
  const fromLogin = location.state?.fromLogin;
  
  // OPERATION USERS: Always redirect to Product Management if trying to access Dashboard
  if (isOperation && location.pathname === '/adminDashboard' && !fromLogin) {
    console.log('🔄 ProtectedRoute: Operation user trying to access Dashboard - redirecting to Product Management');
    return <Navigate to="/productManagement" replace />;
  }
  
  // VENDOR USERS: Always redirect to Product Management if trying to access Dashboard
  if (isVendor && location.pathname === '/adminDashboard' && !fromLogin) {
    console.log('🔄 ProtectedRoute: Vendor user trying to access Dashboard - redirecting to Product Management');
    return <Navigate to="/productManagement" replace />;
  }
  
  // SUPER ADMIN: Always allow access
  if (isSuperAdmin) {
    console.log("✅ Super Admin - Access granted");
    return <>{children}</>;
  }
  
  // If allowedRoles is specified, check against it
  if (allowedRoles.length > 0) {
    // Normalize role names for comparison
    const normalizedUserRole = userRole.toLowerCase().trim();
    const normalizedAllowedRoles = allowedRoles.map(role => role.toLowerCase().trim());
    
    // Check if user role is in allowed roles
    const isRoleAllowed = normalizedAllowedRoles.some(role => 
      normalizedUserRole === role || 
      (role === 'super admin' && normalizedUserRole.includes('super'))
    );
    
    if (!isRoleAllowed) {
      console.log(`❌ ProtectedRoute: Role '${userRole}' not in allowed roles: ${allowedRoles.join(', ')}`);
      
      // Redirect operation users to Product Management
      if (isOperation) {
        return <Navigate to="/productManagement" replace />;
      }
      
      // Redirect vendor users to Product Management
      if (isVendor) {
        return <Navigate to="/productManagement" replace />;
      }
      
      // For Admin users trying to access super admin only pages
      if (isAdmin && location.pathname === '/adminDashboard') {
        return <Navigate to="/adminDashboard" replace />;
      }
      
      // For others, use provided redirectTo or go to dashboard
      return <Navigate to={redirectTo || "/adminDashboard"} replace />;
    }
    
    console.log(`✅ ProtectedRoute: Role '${userRole}' is in allowed roles: ${allowedRoles.join(', ')}`);
    return <>{children}</>;
  }
  
  // Default role-based access (if no allowedRoles specified)
  const currentPath = location.pathname;
  
  console.log("🛡️ Default access check for:", currentPath);
  
  // Define access maps for each role
  const adminAccess = [
    '/adminDashboard', '/Userlist', '/productManagement', '/categoryManagement',
    '/unitManagement', '/adminOrderManagement', '/bulkOrderManagement', '/WarrantyManagement',
    '/subcategorymanagement', '/DeliveryAgentManagement', '/WarehouseManagement',
    '/banner', '/subbanner', '/review', '/guestOrderlist',
    '/guestUserOrder', '/SetCredit', '/pickupPending', '/ProductWarehouseManagement',
    '/dealoftheday', '/couponManagement', '/AdminCouponUsers', '/rewardManagement',
    '/RewardSettingsManagement', '/AdminRewards', '/flashSale', '/deliveryManagement',
    '/shippingManagement', '/deliverySettings', '/smtpsettings', '/globalSettings',
    '/smsSettings', '/analytics', '/bundle', '/AdminUserList',
    '/returnprocessManagement' // ADDED: Admin can access Return Process Management
  ];
  
  const operationAccess = [
    '/adminOrderManagement', '/productManagement', '/bulkOrderManagement'
  ];
  
  const vendorAccess = [
    '/productManagement', '/bundleManagment', '/bulkOrderManagement', '/returnprocessManagement'
  ];
  
  let hasAccess = false;
  
  if (isAdmin) {
    hasAccess = adminAccess.includes(currentPath);
    console.log(`👨‍💼 Admin access check for ${currentPath}: ${hasAccess}`);
  } else if (isOperation) {
    hasAccess = operationAccess.includes(currentPath);
    console.log(`👷 Operation access check for ${currentPath}: ${hasAccess}`);
  } else if (isVendor) {
    hasAccess = vendorAccess.includes(currentPath);
    console.log(`🛒 Vendor access check for ${currentPath}: ${hasAccess}`);
  }
  
  if (hasAccess) {
    console.log(`✅ Access granted for ${currentPath}`);
    return <>{children}</>;
  } else {
    console.log(`❌ ProtectedRoute: Default access denied for ${userRole} to ${currentPath}`);
    
    // Redirect operation users to Product Management
    if (isOperation) {
      return <Navigate to="/productManagement" replace />;
    }
    
    // Redirect vendor users to Product Management
    if (isVendor) {
      return <Navigate to="/productManagement" replace />;
    }
    
    // For Admin users, redirect to Dashboard if they don't have access
    if (isAdmin) {
      console.log(`❌ Admin doesn't have access to ${currentPath} - redirecting to Dashboard`);
      return <Navigate to="/adminDashboard" replace />;
    }
    
    return <Navigate to="/adminDashboard" replace />;
  }
};

// Create AccessDenied component
const AccessDenied = () => {
  // Get user role for display
  const userRole = (
    localStorage.getItem('admin_type') || 
    localStorage.getItem('user_role') || 
    'operation'
  ).toLowerCase().trim();
  
  const getRoleName = (role: string) => {
    if (role.includes('super')) return 'Super Admin';
    if (role === 'admin') return 'Admin';
    if (role === 'operation') return 'Operation';
    if (role === 'vendor') return 'Vendor';
    return 'User';
  };

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      flexDirection: 'column',
      backgroundColor: '#f5f5f5',
      padding: '20px'
    }}>
      <h1 style={{ color: '#f44336', fontSize: '48px', marginBottom: '20px' }}>⛔</h1>
      <h2 style={{ color: '#333', marginBottom: '10px' }}>Access Denied</h2>
      <p style={{ color: '#666', textAlign: 'center', maxWidth: '400px', marginBottom: '20px' }}>
        You don't have permission to access this page. 
        <br />
        <strong>Your Role:</strong> {getRoleName(userRole)}
        <br />
        <strong>Page:</strong> {window.location.pathname}
      </p>
      <button 
        onClick={() => {
          // Redirect based on role
          if (userRole === 'operation' || userRole === 'vendor') {
            window.location.href = '/productManagement';
          } else {
            window.location.href = '/adminDashboard';
          }
        }}
        style={{
          marginTop: '10px',
          padding: '10px 20px',
          backgroundColor: '#1976d2',
          color: 'white',
          border: 'none',
          borderRadius: '4px',
          cursor: 'pointer',
          fontWeight: 'bold'
        }}
      >
        Go to Appropriate Page
      </button>
      <button 
        onClick={() => {
          localStorage.removeItem('admin_token');
          localStorage.removeItem('admin_type');
          localStorage.removeItem('admin_email');
          localStorage.removeItem('admin_id');
          localStorage.removeItem('admin_name');
          window.location.href = '/';
        }}
        style={{
          marginTop: '10px',
          padding: '10px 20px',
          backgroundColor: '#f44336',
          color: 'white',
          border: 'none',
          borderRadius: '4px',
          cursor: 'pointer'
        }}
      >
        Logout
      </button>
    </div>
  );
};

// Check if user is logged in
const isLoggedIn = () => {
  return !!localStorage.getItem('admin_token');
};

// Auth wrapper component
const AdminLayout = ({ children }: { children: React.ReactNode }) => {
  if (!isLoggedIn()) {
    return <Navigate to="/" replace />;
  }
  return <>{children}</>;
};

// Main App component
function App() {
  return (
    <>
      <ToastContainer />
      <Router>
        <GlobalRedirect />
        <Routes>
          {/* Root path shows Admin Login */}
          <Route path="/" element={<AdminLogin />} />
          
          {/* Separate admin login route (optional) */}
          <Route path="/adminlogin" element={<AdminLogin />} />
          
          {/* Vendor login */}
          <Route path="/vendorlogin" element={<VendorLogin />} />
          
          {/* Access denied page */}
          <Route path="/access-denied" element={<AccessDenied />} />
          
          {/* Customer Routes (if you still need them) */}
          <Route path="/customer/signin" element={<SignIn />} />
          <Route path="/customer/signup" element={<SignUp />} />
          <Route path="/customer/otp-verification-signin" element={<VerifyOTPSignin />} />
          <Route path="/customer/otp-verification-signup" element={<VerifyOTPSignup />} />
          <Route path="/customer/ap" element={<PasswordAssistance />} />
          <Route path="/customer/ap-email-verification" element={<AP_Email_Verification />} />
          <Route path="/customer/ap-number-verification" element={<AP_Number_Verification />} />
          <Route path="/customer/reset-ap" element={<ResetNewPassword />} />
          <Route path="/customer/my-account" element={<UserProfile />} />
          <Route path="/customer/cart" element={<Cart />} />
          <Route path="/customer/payment-method" element={<PaymentMethod />} />
          <Route path="/customer/confirm-order" element={<ConfirmOrder />} />
          <Route path="/customer/order-placed" element={<OrderPlaced />} />
          <Route path="/customer/view-order" element={<ViewOrder />} />
          <Route path="/customer/products" element={<Product />} />
          <Route path="/customer/product-detail" element={<ProductDetail />} />
          <Route path="/customer/stripe-checkout" element={<StripeCheckout />} />
          
          {/* ADMIN DASHBOARD - Restricted for operation/vendor users */}
          <Route path="/adminDashboard" element={
            <AdminLayout>
              <ProtectedRoute allowedRoles={['super admin', 'admin']} redirectTo="/productManagement">
                <AdminDashboard />
              </ProtectedRoute>
            </AdminLayout>
          } />
          
          {/* OPERATION USER ROUTES - Product Management, Order Management, and Bulk Order Management */}
          
          <Route path="/productManagement" element={
            <AdminLayout>
              <ProtectedRoute allowedRoles={['super admin', 'admin', 'operation', 'vendor']}>
                <ProductManagement />
              </ProtectedRoute>
            </AdminLayout>
          } />
          
          <Route path="/adminOrderManagement" element={
            <AdminLayout>
              <ProtectedRoute allowedRoles={['super admin', 'admin', 'operation']}>
                <AdminOrderManagement />
              </ProtectedRoute>
            </AdminLayout>
          } />
          
          {/* BULK ORDER MANAGEMENT - ACCESSIBLE TO ALL USER TYPES */}
          <Route path="/bulkOrderManagement" element={
            <AdminLayout>
              <ProtectedRoute allowedRoles={['super admin', 'admin', 'operation', 'vendor']}>
                <BulkOrderManagement />
              </ProtectedRoute>
            </AdminLayout>
          } />

          {/* BUNDLE MANAGEMENT - ACCESSIBLE TO ADMIN, SUPER ADMIN, AND VENDOR */}
          <Route path="/bundleManagment" element={
            <AdminLayout>
              <ProtectedRoute allowedRoles={['super admin', 'admin', 'vendor']}>
                <BundleManagement />
              </ProtectedRoute>
            </AdminLayout>
          } />

          {/* RETURN PROCESS MANAGEMENT - ACCESSIBLE TO ADMIN, SUPER ADMIN, AND VENDOR */}
          <Route path="/returnprocessManagement" element={
            <AdminLayout>
              <ProtectedRoute allowedRoles={['super admin', 'admin', 'vendor']}>
                <ReturnProcessManagement />
              </ProtectedRoute>
            </AdminLayout>
          } />
          
          {/* ADMIN ONLY ROUTES (Operation users CANNOT access these) */}
          
          <Route path="/Userlist" element={
            <AdminLayout>
              <ProtectedRoute allowedRoles={['super admin', 'admin']} redirectTo="/productManagement">
                <UserList />
              </ProtectedRoute>
            </AdminLayout>
          } />
          
          <Route path="/categorymanagement" element={
            <AdminLayout>
              <ProtectedRoute allowedRoles={['super admin', 'admin']} redirectTo="/productManagement">
                <CategoryManagement />
              </ProtectedRoute>
            </AdminLayout>
          } />
          
          <Route path="/unitmanagement" element={
            <AdminLayout>
              <ProtectedRoute allowedRoles={['super admin', 'admin']} redirectTo="/productManagement">
                <UnitManagement />
              </ProtectedRoute>
            </AdminLayout>
          } />
          
          <Route path="/WarrantyManagement" element={
            <AdminLayout>
              <ProtectedRoute allowedRoles={['super admin', 'admin']} redirectTo="/productManagement">
                <WarrantyManagement />
              </ProtectedRoute>
            </AdminLayout>
          } />
          
          <Route path="/subcategorymanagement" element={
            <AdminLayout>
              <ProtectedRoute allowedRoles={['super admin', 'admin']} redirectTo="/productManagement">
                <SubCategoryManagement />
              </ProtectedRoute>
            </AdminLayout>
          } />
          
          <Route path="/DeliveryAgentManagement" element={
            <AdminLayout>
              <ProtectedRoute allowedRoles={['super admin', 'admin']} redirectTo="/productManagement">
                <DeliveryAgentManagement />
              </ProtectedRoute>
            </AdminLayout>
          } />
          
          <Route path="/WarehouseManagement" element={
            <AdminLayout>
              <ProtectedRoute allowedRoles={['super admin', 'admin']} redirectTo="/productManagement">
                <WareHoueManagement />
              </ProtectedRoute>
            </AdminLayout>
          } />
          
          <Route path="/banner" element={
            <AdminLayout>
              <ProtectedRoute allowedRoles={['super admin', 'admin']} redirectTo="/productManagement">
                <Banner />
              </ProtectedRoute>
            </AdminLayout>
          } />
          
          <Route path="/subbanner" element={
            <AdminLayout>
              <ProtectedRoute allowedRoles={['super admin', 'admin']} redirectTo="/productManagement">
                <SubBanner />
              </ProtectedRoute>
            </AdminLayout>
          } />
          
          <Route path="/review" element={
            <AdminLayout>
              <ProtectedRoute allowedRoles={['super admin', 'admin']} redirectTo="/productManagement">
                <ReviewManagement />
              </ProtectedRoute>
            </AdminLayout>
          } />
          
          <Route path="/guestOrderlist" element={
            <AdminLayout>
              <ProtectedRoute allowedRoles={['super admin', 'admin']} redirectTo="/productManagement">
                <GuestOrderList />
              </ProtectedRoute>
            </AdminLayout>
          } />
          
          <Route path="/guestUserOrder" element={
            <AdminLayout>
              <ProtectedRoute allowedRoles={['super admin', 'admin']} redirectTo="/productManagement">
                <GuestUserOrder />
              </ProtectedRoute>
            </AdminLayout>
          } />
          
          <Route path="/SetCredit" element={
            <AdminLayout>
              <ProtectedRoute allowedRoles={['super admin', 'admin']} redirectTo="/productManagement">
                <SetCredit />
              </ProtectedRoute>
            </AdminLayout>
          } />
          
          <Route path="/pickupPending" element={
            <AdminLayout>
              <ProtectedRoute allowedRoles={['super admin', 'admin']} redirectTo="/productManagement">
                <PickupPending />
              </ProtectedRoute>
            </AdminLayout>
          } />
          
          <Route path="/ProductWarehouseManagement" element={
            <AdminLayout>
              <ProtectedRoute allowedRoles={['super admin', 'admin']} redirectTo="/productManagement">
                <ProductWarehouseManagement />
              </ProtectedRoute>
            </AdminLayout>
          } />
          
          <Route path="/dealoftheday" element={
            <AdminLayout>
              <ProtectedRoute allowedRoles={['super admin', 'admin']} redirectTo="/productManagement">
                <DealOfTheDay />
              </ProtectedRoute>
            </AdminLayout>
          } />
          
          <Route path="/couponManagement" element={
            <AdminLayout>
              <ProtectedRoute allowedRoles={['super admin', 'admin']} redirectTo="/productManagement">
                <CouponManagement />
              </ProtectedRoute>
            </AdminLayout>
          } />
          
          <Route path="/AdminCouponUsers" element={
            <AdminLayout>
              <ProtectedRoute allowedRoles={['super admin', 'admin']} redirectTo="/productManagement">
                <AdminCouponUsers />
              </ProtectedRoute>
            </AdminLayout>
          } />
          
          <Route path="/rewardManagement" element={
            <AdminLayout>
              <ProtectedRoute allowedRoles={['super admin', 'admin']} redirectTo="/productManagement">
                <RewardManagement />
              </ProtectedRoute>
            </AdminLayout>
          } />
          
          <Route path="/RewardSettingsManagement" element={
            <AdminLayout>
              <ProtectedRoute allowedRoles={['super admin', 'admin']} redirectTo="/productManagement">
                <RewardSettingsManagement />
              </ProtectedRoute>
            </AdminLayout>
          } />
          
          <Route path="/AdminRewards" element={
            <AdminLayout>
              <ProtectedRoute allowedRoles={['super admin', 'admin']} redirectTo="/productManagement">
                <AdminRewards />
              </ProtectedRoute>
            </AdminLayout>
          } />
          
          <Route path="/flashSale" element={
            <AdminLayout>
              <ProtectedRoute allowedRoles={['super admin', 'admin']} redirectTo="/productManagement">
                <FlashSale />
              </ProtectedRoute>
            </AdminLayout>
          } />
          
          <Route path="/deliveryManagement" element={
            <AdminLayout>
              <ProtectedRoute allowedRoles={['super admin', 'admin']} redirectTo="/productManagement">
                <DeliveryManagement />
              </ProtectedRoute>
            </AdminLayout>
          } />
          
          <Route path="/shippingManagement" element={
            <AdminLayout>
              <ProtectedRoute allowedRoles={['super admin', 'admin']} redirectTo="/productManagement">
                <ShippingManagement />
              </ProtectedRoute>
            </AdminLayout>
          } />
          
          <Route path="/deliverySettings" element={
            <AdminLayout>
              <ProtectedRoute allowedRoles={['super admin', 'admin']} redirectTo="/productManagement">
                <Delivery />
              </ProtectedRoute>
            </AdminLayout>
          } />
          
          {/* Super Admin Only Routes */}
          <Route path="/AdminUserList" element={
            <AdminLayout>
              <ProtectedRoute allowedRoles={['super admin']} redirectTo="/productManagement">
                <AdminUserList />
              </ProtectedRoute>
            </AdminLayout>
          } />
          
          <Route path="/roleMaster" element={
            <AdminLayout>
              <ProtectedRoute allowedRoles={['super admin']} redirectTo="/productManagement">
                <RoleMaster />
              </ProtectedRoute>
            </AdminLayout>
          } />  

          
          
          <Route path="/RoleMapping" element={
            <AdminLayout>
              <ProtectedRoute allowedRoles={['super admin']} redirectTo="/productManagement">
                <RoleMappingManagement />
              </ProtectedRoute>
            </AdminLayout>
          } />
          
          <Route path="/RegisterAdmin" element={
            <AdminLayout>
              <ProtectedRoute allowedRoles={['super admin']} redirectTo="/productManagement">
                <RegisterAdmin />
              </ProtectedRoute>
            </AdminLayout>
          } />
          
          {/* Admin Only Settings Routes */}
          <Route path="/smtpsettings" element={
            <AdminLayout>
              <ProtectedRoute allowedRoles={['super admin', 'admin']} redirectTo="/productManagement">
                <SmptSettings />
              </ProtectedRoute>
            </AdminLayout>
          } />
          
          <Route path="/globalSettings" element={
            <AdminLayout>
              <ProtectedRoute allowedRoles={['super admin', 'admin']} redirectTo="/productManagement">
                <GlobalSettings />
              </ProtectedRoute>
            </AdminLayout>
          } />
          
          <Route path="/smtpsettings" element={
            <AdminLayout>
              <ProtectedRoute allowedRoles={['super admin', 'admin']} redirectTo="/productManagement">
                <SmsSettings />
              </ProtectedRoute>
            </AdminLayout>
          } />
          
          {/* Other admin routes */}
          <Route path="/manageproduct" element={
            <AdminLayout>
              <ProtectedRoute allowedRoles={['super admin', 'admin']} redirectTo="/productManagement">
                <ManageProduct />
              </ProtectedRoute>
            </AdminLayout>
          } />
          
          <Route path="/addproduct" element={
            <AdminLayout>
              <ProtectedRoute allowedRoles={['super admin', 'admin']} redirectTo="/productManagement">
                <Addproduct />
              </ProtectedRoute>
            </AdminLayout>
          } />
          
          <Route path="/analytics" element={
            <AdminLayout>
              <ProtectedRoute allowedRoles={['super admin', 'admin']} redirectTo="/productManagement">
                <Analytics />
              </ProtectedRoute>
            </AdminLayout>
          } />
          
          <Route path="/pickupmessage" element={
            <AdminLayout>
              <ProtectedRoute allowedRoles={['super admin', 'admin']} redirectTo="/productManagement">
                <PickupMessage />
              </ProtectedRoute>
            </AdminLayout>
          } />
          
          <Route path="/bundle" element={
            <AdminLayout>
              <ProtectedRoute allowedRoles={['super admin', 'admin']} redirectTo="/productManagement">
                <Bundle />
              </ProtectedRoute>
            </AdminLayout>
          } />
          
          {/* Legacy routes (keep for compatibility) */}
          <Route path="/adminHeader" element={
            <AdminLayout>
              <AdminHeader onToggleMenu={undefined} />
            </AdminLayout>
          } />
          
          <Route path="/slidemenu" element={
            <AdminLayout>
              <Slidemenu mobileOpen={false} onToggle={function (): void {
                throw new Error('Function not implemented.');
              }} />
            </AdminLayout>
          } />
          
          <Route path="/orderManagement" element={
            <AdminLayout>
              <OrderManagement mobileOpen={false} onToggle={function (): void {
                throw new Error('Function not implemented.');
              }} />
            </AdminLayout>
          } />
          
        </Routes>  
      </Router>
    </>
  );
}

export default App;